import { html } from "lit";
import { customElement, query, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./AddPlaceToUserListDialog.style";

import "../PlaceListPicker/PlaceListPicker";
import {
    IPlaceList,
    IPlaceListTable,
    makeEmptyPlaceListEntry,
} from "../../backend/IPlaceListTable";

export function openAddPlaceToUserListDialog(
    props: any,
    approved: any = () => {},
    cancelled: any = () => {}
) {
    const dialog = Object.assign(document.createElement("ds-add-place-to-user-list-dialog"), props);
    dialog.addEventListener("on-approved", () => {
        approved();
    });
    dialog.addEventListener("on-cancel", () => {
        cancelled();
    });
    document.body.append(dialog);
}

@customElement("ds-add-place-to-user-list-dialog")
export class AddPlaceToUserListDialog extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: Boolean }) open = false;
    @property({ type: String }) placeId?: string;

    @state() protected _selectedList?: IPlaceList;

    @query("#dialog") _dialog: HTMLElement | undefined;

    public show() {
        (this._dialog as any).show();
    }

    private hide() {
        (this._dialog as any).hide();
    }

    protected override firstUpdated(): void {
        if (this.open) {
            this.show();
        }
    }
    protected cancel() {
        this.dispatchEvent(
            new CustomEvent("on-cancel", {
                bubbles: true,
                composed: true,
                detail: {},
            })
        );
        this.hide();
    }

    private async _addToList() {
        if (this._selectedList && this.placeId) {
            const table = this._kernel.dataStore.getSource<IPlaceListTable>("place-list");
            table.createEntry(
                this._selectedList.id,
                Object.assign(makeEmptyPlaceListEntry(), {
                    place: this.placeId,
                })
            );
        }
    }

    override render() {
        return html`<sl-dialog label="Save to list" id="dialog">
            <ds-place-list-picker
                .userId=${this._kernel.user?.id}
                @ds-selected=${(e: CustomEvent) => {
                    this._selectedList = e.detail.list;
                }}
            ></ds-place-list-picker>
            <div slot="footer">
                <sl-button variant="default" @click=${() => this.cancel()}>Cancel</sl-button>

                <sl-button
                    variant="success"
                    ?disabled=${!this._selectedList}
                    @click=${async () => {
                        await this._addToList();
                        this.dispatchEvent(
                            new CustomEvent("on-approved", {
                                bubbles: true,
                                composed: true,
                                detail: {},
                            })
                        );
                        this.hide();
                    }}
                    >Add to List</sl-button
                >
            </div>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-add-place-to-user-list-dialog": AddPlaceToUserListDialog;
    }
}
